// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--22w0l";
export var wrapper = "styles-module--wrapper--3EuC8";
export var body = "styles-module--body--1--Iw";
export var links = "styles-module--links--1jnGp";